import { render, staticRenderFns } from "./employeeCard.vue?vue&type=template&id=b111c7f2&scoped=true"
import script from "./employeeCard.vue?vue&type=script&lang=js"
export * from "./employeeCard.vue?vue&type=script&lang=js"
import style0 from "./employeeCard.vue?vue&type=style&index=0&id=b111c7f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b111c7f2",
  null
  
)

export default component.exports